import { useState } from "react";
import { Popover, message, FloatButton, Button, Form, Input } from "antd";
import { BugOutlined } from "@ant-design/icons";
import useAuthStore from '@/stores/AuthStore'
import { sendNotify } from "@/utils/pagespy";
import { uploadPageSpyLog } from "@haina/utils-pagespy";

function LogUploader() {
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const [loginUser] = useAuthStore((s) => [s.loginUser]);

  const [messageApi, contextHolder] = message.useMessage();
  const [formBug] = Form.useForm();

  const popoverContent = (
    <Form
      layout={"vertical"}
      form={formBug}
      initialValues={{ problem: '' }}
      scrollToFirstError
      onFinish={async (values) => {
        const success = await uploadPageSpyLog();
        messageApi.success("Thanks for the feedback😊");
        if (success) {
          sendNotify(`${loginUser?.username}(${loginUser?.userIdStr})说：${values.problem}`);
        } else {
          sendNotify(`${loginUser?.username}(${loginUser?.userIdStr})上传日志失败`);
        }
        hide();
        formBug.setFieldsValue({problem: ''});
      }}
    >
      <Form.Item
        name="problem"
        label="Need help?"
        rules={[{ required: true, message: "Specify issue needing support." }]}
      >
        <Input.TextArea rows={3} />
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        color="cyan"
        variant="solid"
        block
      >
        Submit
      </Button>
    </Form>
  );

  return (
    <>
      {contextHolder}
      <Popover
        content={popoverContent}
        trigger={["click"]}
        placement="topRight"
        open={open}
        onOpenChange={handleOpenChange}
        fresh
        destroyOnHidden
      >
        <FloatButton icon={<BugOutlined />} tooltip={<div>上传日志给研发部</div>} />
      </Popover>
    </>
  );
}

export default LogUploader;
